const routeMain = () => "/concept";

export default routeMain;
